var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "msg",
        {
          self: _vm.message.self,
          highlight: _vm.message.highlight || _vm.focused,
          "previous-source": _vm.isPreviousSource,
        },
      ],
      attrs: {
        id: "msg-" + _vm.message.id,
        "data-type": _vm.message.type,
        "data-command": _vm.message.command,
        "data-from": _vm.message.from && _vm.message.from.nick,
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "time tooltipped tooltipped-e",
          attrs: { "aria-hidden": "true", "aria-label": _vm.messageTimeLocale },
        },
        [_vm._v(_vm._s(_vm.messageTime) + "\n\t")]
      ),
      _vm.message.type === "unhandled"
        ? [
            _c("span", { staticClass: "from" }, [
              _vm._v("[" + _vm._s(_vm.message.command) + "]"),
            ]),
            _c(
              "span",
              { staticClass: "content" },
              _vm._l(_vm.message.params, function (param, id) {
                return _c("span", { key: id }, [_vm._v(_vm._s(param) + " ")])
              }),
              0
            ),
          ]
        : _vm.isAction()
        ? [
            _vm._m(0),
            _c(_vm.messageComponent, {
              tag: "component",
              attrs: { network: _vm.network, message: _vm.message },
            }),
          ]
        : _vm.message.type === "action"
        ? [
            _vm._m(1),
            _c(
              "span",
              { staticClass: "content", attrs: { dir: "auto" } },
              [
                _c("Username", {
                  attrs: {
                    user: _vm.message.from,
                    network: _vm.network,
                    channel: _vm.channel,
                    dir: "auto",
                  },
                }),
                _vm._v(" "),
                _c("ParsedMessage", { attrs: { message: _vm.message } }),
                _vm._l(_vm.message.previews, function (preview) {
                  return _c("LinkPreview", {
                    key: preview.link,
                    attrs: {
                      "keep-scroll-position": _vm.keepScrollPosition,
                      link: preview,
                      channel: _vm.channel,
                    },
                  })
                }),
              ],
              2
            ),
          ]
        : [
            _vm.message.type === "message"
              ? _c(
                  "span",
                  { staticClass: "from" },
                  [
                    _vm.message.from && _vm.message.from.nick
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("<")]
                          ),
                          _c("Username", {
                            attrs: {
                              user: _vm.message.from,
                              network: _vm.network,
                              channel: _vm.channel,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("> ")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm.message.type === "plugin"
              ? _c(
                  "span",
                  { staticClass: "from" },
                  [
                    _vm.message.from && _vm.message.from.nick
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("[")]
                          ),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.message.from.nick) +
                              "\n\t\t\t\t"
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("] ")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _c(
                  "span",
                  { staticClass: "from" },
                  [
                    _vm.message.from && _vm.message.from.nick
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("-")]
                          ),
                          _c("Username", {
                            attrs: {
                              user: _vm.message.from,
                              network: _vm.network,
                              channel: _vm.channel,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "only-copy",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("- ")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
            _c(
              "span",
              { staticClass: "content", attrs: { dir: "auto" } },
              [
                _vm.message.showInActive
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "msg-shown-in-active tooltipped tooltipped-e",
                        attrs: {
                          "aria-label":
                            "This message was shown in your active channel",
                        },
                      },
                      [_c("span")]
                    )
                  : _vm._e(),
                _vm.message.statusmsgGroup
                  ? _c(
                      "span",
                      {
                        staticClass: "msg-statusmsg tooltipped tooltipped-e",
                        attrs: {
                          "aria-label":
                            "This message was only shown to users with " +
                            _vm.message.statusmsgGroup +
                            " mode",
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.message.statusmsgGroup))])]
                    )
                  : _vm._e(),
                _c("ParsedMessage", {
                  attrs: { network: _vm.network, message: _vm.message },
                }),
                _vm._l(_vm.message.previews, function (preview) {
                  return _c("LinkPreview", {
                    key: preview.link,
                    attrs: {
                      "keep-scroll-position": _vm.keepScrollPosition,
                      link: preview,
                      channel: _vm.channel,
                    },
                  })
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "from" }, [
      _c("span", { staticClass: "only-copy" }, [_vm._v("*** ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "from" }, [
      _c("span", { staticClass: "only-copy" }, [_vm._v("* ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }